<template>
  <div class="rules__card" :class="[getColor, getShape, setLayoutColor]">
    <div class="rules__card_text">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "RulesCard",
  props: {
    text: {
      type: String,
    },
    color: {
      type: String,
    },
    shape: {
      type: String,
    },
  },
  computed: {
    getColor() {
      return `rules__card-${this.color}`;
    },
    getShape() {
      return `rules__card-${this.shape}`;
    },
    layoutColor() {
      return this.$store.getters.GET_LAYOUT_COLOR;
    },
    setLayoutColor() {
      return `rules__card_layout_${this.layoutColor}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.rules__card {
  width: 310px;
  height: 323px;
  padding: 64px 40px;
  text-align: center;
  display: flex;
  align-items: center;
  flex-shrink: 0;

  &_layout_purple {
    &.rules__card-blue {
      background-color: $color-blue;
    }

    &.rules__card-purple {
      background-color: $color-purple-30;
    }

    &.rules__card-orchid {
      background-color: $color-orchid;
    }

    &.rules__card-red {
      background-color: $color-red;
    }
  }

  &_layout_red {
    &.rules__card-blue {
      background-color: $color-violet;
    }

    &.rules__card-purple {
      background-color: $color-green;
    }

    &.rules__card-orchid {
      background-color: $color-orange;
    }

    &.rules__card-red {
      background-color: $color-dark-yellow;
    }
  }

  &-round {
    border-radius: 50%;
  }

  &-bottom-left {
    border-radius: 50% 50% 50% 0;
  }

  &-left {
    border-radius: 0 50% 50% 0;
  }

  &-top-right {
    border-radius: 50% 0 50% 50%;
  }

  &_text {
    @include font("CeraPro", 28px, 500);
  }
}
</style>
